var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 31,
    viewBox: "0 0 44 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 2C7.52273 2 2 15.5 2 15.5C2 15.5 7.52273 29 22.25 29C36.9773 29 42.5 15.5 42.5 15.5C42.5 15.5 36.9773 2 22.25 2ZM22.25 5.375C31.9626 5.375 36.8753 12.5757 38.4658 15.4934C36.8734 18.3908 31.924 25.625 22.25 25.625C12.5374 25.625 7.62473 18.4243 6.03418 15.5066C7.62841 12.6092 12.576 5.375 22.25 5.375ZM22.25 8.75C18.1834 8.75 14.8864 11.7723 14.8864 15.5C14.8864 19.2277 18.1834 22.25 22.25 22.25C26.3166 22.25 29.6136 19.2277 29.6136 15.5C29.6136 11.7723 26.3166 8.75 22.25 8.75ZM22.25 12.125C24.2842 12.125 25.9318 13.6353 25.9318 15.5C25.9318 17.3647 24.2842 18.875 22.25 18.875C20.2158 18.875 18.5682 17.3647 18.5682 15.5C18.5682 13.6353 20.2158 12.125 22.25 12.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 2L2 29",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigEyeIcon);
export default __webpack_public_path__ + "static/media/bigEyeIcon.81ea16a580a4f20b25a1c1f94943f654.svg";
export { ForwardRef as ReactComponent };